import type { App } from 'vue'
import type { I18n } from 'vue-i18n'
import { createI18n } from 'vue-i18n'
import { cookieRef } from '@layouts/stores/config'
import { themeConfig } from '@themeConfig'

type MessageSchema = Record<string, string>
type LocaleMessages = Record<string, MessageSchema>

const messages: LocaleMessages = Object.fromEntries(
  Object.entries(
    import.meta.glob<{ default: MessageSchema }>('./locales/*.json', { eager: true }))
    .map(([key, value]) => [key.slice(10, -5), value.default]),
)

let _i18n: I18n<LocaleMessages, Record<string, never>, Record<string, never>, string, false> | null = null

export const getI18n = () => {
  if (_i18n === null) {
    _i18n = createI18n({
      legacy: false,
      locale: cookieRef('language', themeConfig.app.i18n.defaultLocale).value,
      fallbackLocale: 'en',
      messages,
    })
  }

  return _i18n
}

export default function (app: App) {
  app.use(getI18n())
}
